module.exports = __webpack_public_path__ + "img/fuison5-main.8bfd760e.webp";